export default __webpack_public_path__ + "static/media/FirstBase-1.ad11aa9d.jpg";